<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card" *ngFor="let releaseNote of releaseNotes">
          <div class="card-header card-header-text card-header-primary">
            <div class="card-text pt-1">
              <h4 class="card-title">{{'general.version' | translate}} {{releaseNote.version}} ({{releaseNote.date | date:'fullDate'}})</h4>
            </div>
          </div>
          <div class="card-body table-responsive">
            <table class="table table-hover" *ngFor="let componentChange of releaseNote.componentChanges">
              <tbody>
                <tr class="release-notes-row" *ngFor="let change of componentChange.changes">
                  <td>{{change}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
